import * as React from "react";

interface TwitterIconProps {
	iconColor: string;
	style: any;
	onClick?: () => void;
}

const TwitterIcon = (props: TwitterIconProps) => (
	<svg
		width="38px"
		height="38px"
		viewBox="0 0 45 45"
		version="1.1"
		style={props.style}
		onClick={props.onClick}
	>
		<g
			id="1440x-1024"
			stroke="none"
			strokeWidth="1"
			fill="none"
			fillRule="evenodd"
			transform="translate(-518.000000, -926.000000)"
		>
			<g
				id="Social-Media-Icons"
				transform="translate(518.000000, 922.000000)"
				fill={props.iconColor}
				fillRule="nonzero"
			>
				<path
					d="M48.8678889,9.66362502 C47.0506143,10.4607825 45.1142242,10.9891665 43.0953695,11.2457229 C45.1722548,10.0057002 46.7574069,8.05709318 47.5026422,5.70838027 C45.5662521,6.86288414 43.428282,7.67836704 41.1498167,8.13344925 C39.3111624,6.17567946 36.6906218,4.96314496 33.8318503,4.96314496 C28.2853449,4.96314496 23.8200416,9.46509923 23.8200416,14.9841164 C23.8200416,15.7782196 23.8872349,16.5417804 24.0521641,17.2686902 C15.7232432,16.8624759 8.35335475,12.8705802 3.40242676,6.78958231 C2.53807598,8.28921565 2.03107163,10.0057002 2.03107163,11.8535173 C2.03107163,15.3231374 3.81780382,18.3987602 6.48110376,20.1793839 C4.87151767,20.1488414 3.29247401,19.6815422 1.95471555,18.9454697 C1.95471555,18.9760121 1.95471555,19.0157173 1.95471555,19.0554224 C1.95471555,23.9238858 5.42738991,27.9677036 9.9812663,28.8992478 C9.16578341,29.1222075 8.27699868,29.229106 7.35461727,29.229106 C6.71322623,29.229106 6.06572671,29.1924551 5.45793234,29.0580684 C6.75598564,33.0255301 10.4394028,35.9423323 14.8191873,36.0370138 C11.4106521,38.703368 7.08278964,40.3098998 2.3975808,40.3098998 C1.57598942,40.3098998 0.787994708,40.2732489 0,40.1724589 C4.43781516,43.0342846 9.6972217,44.6683047 15.368951,44.6683047 C33.8043621,44.6683047 43.8833642,29.3970894 43.8833642,16.16 C43.8833642,15.7171348 43.868093,15.2895407 43.8467133,14.8650009 C45.8350255,13.4539407 47.5056965,11.6916424 48.8678889,9.66362502 Z"
					id="Shape"
				/>
			</g>
		</g>
	</svg>
);

export default TwitterIcon;



// WEBPACK FOOTER //
// ./src/components/Footer/TwitterIcon.tsx